<template>
  <v-row justify="center">
    <v-dialog
      :value="dialogProp"
      @click:outside="closeDialog()"
      scrollable
      max-width="500"
    >
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <v-card tag="form" @submit.prevent="handleSubmit(submitForm)">
          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            rounded
            height="6"
          ></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                {{ titleMode }} Boton
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense>
                  <!-- Nombre -->
                  <v-col cols="12">
                    <ValidationProvider
                      name="Nombre"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        prepend-inner-icon="mdi-label-variant"
                        type="text"
                        color="blue-grey"
                        v-model="formData.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <!-- Cantidad -->
                  <v-col cols="12">
                    <ValidationProvider
                      name="Cantidad"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cantidad"
                        name="quantity"
                        prepend-inner-icon="mdi-numeric"
                        color="blue-grey"
                        v-model="formData.quantity"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <!-- Costo -->
                  <v-col cols="12">
                    <ValidationProvider
                      name="Costo"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Costo"
                        name="cost"
                        prepend-inner-icon="mdi-currency-usd"
                        color="blue-grey"
                        v-model="formData.cost"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <!-- RTC -->
                  <v-col cols="12">
                    <ValidationProvider name="RTC" rules="required" v-slot="{ errors }">
                      <v-select
                        v-model="formData.webrtc_id"
                        :items="rtcList"
                        :error-messages="errors"
                        :loading="isLoadingSelect"
                        class="rounded-small"
                        item-text="public_identity"
                        color="blue-grey"
                        item-value="id"
                        prepend-inner-icon="mdi-database"
                        label="RTC"
                        dense
                        filled
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <!-- A responder -->
                  <v-col cols="12">
                    <ValidationProvider
                      name="Numero a responder"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Numero a responder"
                        name="to_respond"
                        prepend-inner-icon="mdi-phone-forward"
                        color="blue-grey"
                        v-model="formData.to_respond"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <!-- Tiempo -->
                  <v-col cols="12">
                    <ValidationProvider
                      name="Tiempo"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Tiempo (minutos)"
                        name="time_use_minutes"
                        prepend-inner-icon="mdi-clock-time-eight-outline"
                        color="blue-grey"
                        v-model="formData.time_use_minutes"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closeDialog()"
              >
                Cancelar
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click.stop="handleSubmit(submitForm)"
              >
                {{ submitButtonMode }}
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";

const initialData = {
  name: "",
  quantity: 0,
  cost: 0,
  to_respond: "0",
  webrtc_id: 0,
  time_use_minutes: 0,
};

export default {
  props: {
    dialogProp: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "register",
    },
    dataToForm: {
      type: Object,
    },
  },
  components: { vuescroll },
  data() {
    return {
      dialog: this.dialogProp,
      loading: false,
      isLoadingSelect: false,
      activeAlert: false,
      formData: { ...initialData },
      rtcList: [],
    };
  },
  beforeUpdate() {
    if (this.dialogProp) this.getRTCs();
    if (this.dialogProp && this.mode !== "register")
      this.formData = { ...this.dataToForm };
  },
  computed: {
    titleMode() {
      return this.mode === "register" ? "Nueva" : "Editar";
    },
    submitButtonMode() {
      return this.mode === "register" ? "añadir" : "actualizar";
    },
  },

  methods: {
    closeDialog(data = false) {
      this.formData = { ...initialData };
      this.$refs.obs.reset();
      this.$emit("dialog:close", data);
    },
    async getRTCs() {
      this.isLoadingSelect = true;
      try {
        const { data } = await PbxHttpClient.get(`/admin/index_select/webrtc`);
        this.rtcList = data;
      } catch (err) {
        console.log("err", err);
      }
      this.isLoadingSelect = false;
    },
    async submitForm() {
      this.loading = true;
      try {
        if (this.mode === "register") {
          const { data } = await PbxHttpClient.post("/admin/call_button", this.formData);
          this.$snotify.success("Boton creado con éxito.", "¡Hecho!");
          this.closeDialog(data);
        } else {
          const { id, ...payload } = this.formData;
          const { data } = await PbxHttpClient.put(`/admin/call_button/${id}`, payload);
          this.closeDialog(data);
          this.$snotify.success("Boton actualizado con éxito.", "¡Hecho!");
        }
      } catch (err) {
        console.error(err);
        this.$snotify.error("Hubo un error creando el boton ", "Error");
      }
      this.loading = false;
    },
  },
};
</script>
